import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Handle responses and errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth API
export const authAPI = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    getMe: () => api.get('/auth/me')
};

// Groups API
export const groupsAPI = {
    getAll: () => api.get('/groups'),
    create: (data) => api.post('/groups', data),
    update: (id, data) => api.put(`/groups/${id}`, data),
    delete: (id) => api.delete(`/groups/${id}`)
};

// Tasks API
export const tasksAPI = {
    getAll: () => api.get('/tasks'),
    getOne: (id) => api.get(`/tasks/${id}`),
    create: (data) => api.post('/tasks', data),
    update: (id, data) => api.put(`/tasks/${id}`, data),
    delete: (id) => api.delete(`/tasks/${id}`)
};

// Working Tasks API
export const workingTasksAPI = {
    getAll: () => api.get('/working-tasks'),
    add: (taskId) => api.post(`/working-tasks/${taskId}`),
    remove: (taskId) => api.delete(`/working-tasks/${taskId}`),
    start: (taskId) => api.put(`/working-tasks/${taskId}/start`),
    pause: (taskId, timeSpent) => api.put(`/working-tasks/${taskId}/pause`, { timeSpent }),
    complete: (taskId, data) => api.put(`/working-tasks/${taskId}/complete`, data),
    skip: (taskId) => api.put(`/working-tasks/${taskId}/skip`)
};

// Statistics API
export const statisticsAPI = {
    getDashboard: () => api.get('/statistics/dashboard'),
    getTimeTracking: (params) => api.get('/statistics/time-tracking', { params })
};

// Settings API
export const settingsAPI = {
    get: () => api.get('/settings'),
    update: (data) => api.put('/settings', data)
};

export default api;
